var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBonusIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#7F9F17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.68 36.9179C12.68 37.5164 13.1805 38 13.8 38H23.81V25.285H12.68V36.9179ZM26.19 38H36.2C36.8195 38 37.32 37.5164 37.32 36.9179V25.285H26.19V38ZM37.88 17.1691H32.714C33.19 16.4454 33.47 15.5865 33.47 14.6667C33.47 12.0932 31.3035 10 28.64 10C27.191 10 25.8855 10.6222 25 11.6029C24.1145 10.6222 22.809 10 21.36 10C18.6965 10 16.53 12.0932 16.53 14.6667C16.53 15.5865 16.8065 16.4454 17.286 17.1691H12.12C11.5005 17.1691 11 17.6527 11 18.2512V22.9855H23.81V17.1691H26.19V22.9855H39V18.2512C39 17.6527 38.4995 17.1691 37.88 17.1691ZM23.81 17.0338H21.36C20.009 17.0338 18.91 15.972 18.91 14.6667C18.91 13.3614 20.009 12.2995 21.36 12.2995C22.711 12.2995 23.81 13.3614 23.81 14.6667V17.0338ZM28.64 17.0338H26.19V14.6667C26.19 13.3614 27.289 12.2995 28.64 12.2995C29.991 12.2995 31.09 13.3614 31.09 14.6667C31.09 15.972 29.991 17.0338 28.64 17.0338Z",
    fill: "#E1D9CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonusIcon);
export default __webpack_public_path__ + "static/media/bonusIcon.7e8e7f60c4732a0aca782dba2bfbb013.svg";
export { ForwardRef as ReactComponent };